// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.WaybillNumber[data-v-4bb9e69e] {\n  color: #00A551;\n  cursor: pointer;\n  padding: 0;\n}\n.cursorPoniter[data-v-4bb9e69e] {\n  cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
